import React from 'react';
import "../Donate/Donate.css"

const Events = () => {
  return (
    <div className='event-container'>
        <header className='event-header'>
            <section>
              <h3>Our Events</h3>
            </section>
        </header>

        <article className='event-main'>
            <h4>Upcoming Events</h4>
            <hr/>
            <section>
                <h4>Past Events</h4>
                <div className='past-events'>
                    <div>
                        <h6>Let’s Talk Sickle Cell - 2019</h6>
                        <p>
                            September is Sickle cell awereness Month. Centia group of schools, <br />
                            Port- Harcourt was our 2019 Host venue on September 20th,2019. <br />
                            The event started at about 11am with registration of attendees. <br /> <br /> 
                        </p>
                        <p>
                            Highlights of the occasion Includes Sickle cell Education; Pupils, <br /> 
                            Volunteers, Students and Teachers were gathered in the school Hall <br /> 
                            were they were taught about Genotype, it's importance and being a <br />
                            friend to a warrior. The Discussion was handle by Dr. Korubo <br /> 
                            She opened Our hearts to what sickle cell really is and not what <br /> 
                            society has painted it to be. <br /> <br />
                        </p>
                        <p>
                            We were able to provide 105 free genotype screening for pupils and <br />
                            community members.
                        </p>
                    </div>
                    <div>
                        <h6>SCAHF Blood Drive (2nd Edition) - 2019</h6>
                        <p>
                            Was held on same day as Let’s Talk Sickle Cell on 20th September. <br /> 
                            It was Drive and Games and we Recorded over 20 Pints of Blood gotten <br />
                            from Volunteer Blood Donors. The Goodnews was that the Blood was <br /> 
                            first used by accident victims on that day after the event. <br />
                        </p>
                    </div>
                    <div>
                        <h6>World Sickle Cell Day - 2019</h6>
                        <p>
                            June 19th every year has been christened World Sickle Cell Awareness<br /> 
                            Day. It’s a day earmarked to spotlight the menace that Sickle Cell <br />
                            Anaemia is, how preventable it is when people know their genotypes <br />
                            and make wise decisions, how stigmatisation of sufferers of the <br />
                            disease should be discouraged and how more effort, resources and <br />
                            priority is needed in the awareness of the disease and management <br />
                            of sufferers of the disease from the stand point of government and <br />
                            cooperate bodies. <br />
                        </p>
                        <p>
                            At SCAHF it’s one of those days we live for, and it lived up to the <br /> 
                            expectations. This year we collaborated with Sickle Cell Interactive and <br />
                            Management Association (SCIMA) and Sickle Cell awareness. <br />

                        </p>
                    </div>
                    <div>
                        <h6>SCAHF Blood Drive (1st Edition) - 2019</h6>
                        <p>
                            The University of Port Harcourt played host to this event held on 14th <br /> 
                            June 2019, as SCAFH partnered with the office of the Deputy Chief <br /> 
                            Judge, SUG and University of Port Harcourt Teaching Hospital. SCAHF <br /> 
                            Blood Drive 2019 was a resounding success, compared to its premier <br />
                            edition in 2018, significant progress was made as there were more <br />
                            people willing to donate, and much more people after screenings <br />
                            successfully donated. At the end of the day we were able to achieve <br />
                            30 pints of blood. The first beneficiaries of the blood donated at the <br />
                            drive were the victims of the fire outbreak at the Port Harcourt mall. <br />
                        </p>
                    </div>
                    <div>
                        <h6>Let’s Talk Sickle Cell (maiden  edition) - 2018</h6>
                        <p>
                            In June 2018, we held a community awareness project in Woji <br /> 
                            Community Rivers State to celebrate World Sickle Cell day and Blood <br />
                            Donor Day which was our maiden edition. <br /> 
                        </p>
                        <p>
                            We were able to health educate 200 community members, provided <br /> 
                            free genotype screening, blood group test, HIV and Hepatitis screening <br />
                            to 100 members of the community. We were also able to get 20 pints <br /> 
                            of blood for patients at university of Port Harcourt Teaching Hospital. <br />
                        </p>
                    </div>
                    <div>
                        <h6>SCAHF Support Group - since 2018</h6>
                        <p>
                            Whatsapp Support group was created on 16th June 2018. It was <br />
                            created with the aim to provide medical and psychological support <br />
                            to individuals living with sickle cell diseases, help educate family and <br />
                            friends on sickle cell disease. <br />
                        </p>
                        <p>
                            The group is made up of 233 individuals <br />
                            who are in one or the other connected to the condition and the group <br />
                            is saddled with interactive weekly discussions on topics related to <br /> 
                            sickle cell diseases. <br />

                        </p>
                    </div>
                    
                </div>
            </section>

        </article>

    </div>
  )
}

export default Events